import { createComponent } from '@/helpers/alpine';

const ProductOptions = createComponent(() => ({
    isOpen: false,
    count: 0,
    productPrices: 0,
    total: '',

    addProduct(el: HTMLInputElement) {
        const productPrice = el.getAttribute('data-price');

        if (productPrice)
            this.productPrices = this.productPrices + Number(productPrice);

        this.count++;
        this.total = `+ ${this.productPrices.toFixed(2).replace('.', ',')} € `;

        this.$dispatch(`product-options-update`, {
            total: this.total,
            count: this.count,
        });
    },

    removeProduct(el: HTMLInputElement) {
        const productPrice = el.getAttribute('data-price');

        if (productPrice)
            this.productPrices = this.productPrices - Number(productPrice);

        this.count--;

        if (this.count) {
            this.total = `+ ${this.productPrices.toFixed(2).replace('.', ',')} € `;
        } else this.total = '';

        this.$dispatch(`product-options-update`, {
            total: this.total,
            count: this.count,
        });
    },
}));

export { ProductOptions };
